import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import { ArchivedLabel } from 'components/Select/ArchivedLabel';
import { IGetCustomersShort, EntityStatus } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getCustomersShortInfo } from 'backend/customers';
import React, { useMemo } from 'react';

const CustomerField: React.FC = () => {
	const { response, loading, refetch, responseError } = useFetchData<IGetCustomersShort, null>(getCustomersShortInfo);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		const items = response ? response.data.customers : [];

		return items.map((customer) => ({
			...customer,
			additionalContent: customer.status === EntityStatus.Archived ? <ArchivedLabel /> : undefined,
		}));
	}, [response]);

	return (
		<FormSelect
			testId="CustomerField"
			name="selectedCustomer"
			label="customerLabel"
			options={mappedOptions}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			disabled={true}
		/>
	);
};

export default React.memo(CustomerField);
